import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

const FILTERS = {
  all: { name: 'Все', icon: '📬' },
  tax: { name: 'Налоги', icon: '📅' },
  cash: { name: 'Касса', icon: '💰' },
  ai: { name: 'ИИ', icon: '💡' },
  system: { name: 'Система', icon: '⚙️' },
};

function Notifications() {
  const [messages, setMessages] = useState([]);
  const [settings, setSettings] = useState({ tax: true, cash: true, recommendations: true, email_daily: false, frequency: 'instant' });
  const [pushEnabled, setPushEnabled] = useState(false);
  const [filter, setFilter] = useState('all');
  const [emailLog, setEmailLog] = useState([]);
  const [showEmailLog, setShowEmailLog] = useState(false);
  const token = localStorage.getItem('khepri_token');

  useEffect(() => {
    fetchHistory();
    fetchSettings();
    fetchEmailLog();
    checkInactive();
    const interval = setInterval(() => checkInactive(), 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const es = new EventSource(API + '/notifications/stream');
    es.addEventListener('tax_reminder', (e) => {
      if (settings.tax) addToHistory('tax', JSON.parse(e.data));
    });
    es.addEventListener('cash_alert', (e) => {
      if (settings.cash) {
        const data = JSON.parse(e.data);
        addToHistory('cash', data);
        if (pushEnabled && 'Notification' in window && Notification.permission === 'granted') {
          new Notification(data.title, { body: data.message });
        }
      }
    });
    return () => es.close();
  }, [settings, pushEnabled]);

  const fetchHistory = async () => {
    try {
      const res = await fetch(API + '/notifications/history', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) { const d = await res.json(); setMessages(d.notifications || []); }
    } catch (err) { console.error(err); }
  };

  const fetchSettings = async () => {
    try {
      const res = await fetch(API + '/notifications/settings', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) { const d = await res.json(); setSettings(d.settings || settings); }
    } catch (err) { console.error(err); }
  };

  const fetchEmailLog = async () => {
    try {
      const res = await fetch(API + '/notifications/email-log', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) { const d = await res.json(); setEmailLog(d.logs || []); }
    } catch (err) { console.error(err); }
  };

  const checkInactive = async () => {
    try {
      await fetch(API + '/notifications/check-inactive', { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
    } catch (err) { console.error(err); }
  };

  const addToHistory = async (type, data) => {
    setMessages(prev => [{ id: Date.now(), type, title: data.title, message: data.message, read: false, created_at: new Date().toISOString() }, ...prev]);
    try {
      await fetch(API + '/notifications', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ type, title: data.title, message: data.message }),
      });
    } catch (err) { console.error(err); }
  };

  const markRead = async (id) => {
    setMessages(prev => prev.map(m => m.id === id ? { ...m, read: true } : m));
    try { await fetch(API + `/notifications/${id}/read`, { method: 'POST' }); } catch (err) { console.error(err); }
  };

  const toggleSetting = async (key) => {
    const updated = { ...settings, [key]: !settings[key] };
    setSettings(updated);
    try {
      await fetch(API + '/notifications/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(updated),
      });
    } catch (err) { console.error(err); }
  };

  const setFrequency = async (freq) => {
    const updated = { ...settings, frequency: freq };
    setSettings(updated);
    try {
      await fetch(API + '/notifications/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(updated),
      });
    } catch (err) { console.error(err); }
  };

  const enablePush = async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        setPushEnabled(true);
        new Notification('Khepri', { body: 'Push-уведомления включены!' });
      }
    }
  };

  const sendDailyEmail = async () => {
    try {
      await fetch(API + '/notifications/email-daily', { method: 'POST', headers: { Authorization: 'Bearer ' + token } });
      fetchEmailLog();
      alert('Email-сводка отправлена');
    } catch (err) { console.error(err); }
  };

  const unsubscribe = async () => {
    if (!window.confirm('Отписаться от всех уведомлений?')) return;
    const updated = { tax: false, cash: false, recommendations: false, email_daily: false, frequency: 'off' };
    setSettings(updated);
    try {
      await fetch(API + '/notifications/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(updated),
      });
      alert('Вы отписаны от уведомлений');
    } catch (err) { console.error(err); }
  };

  const filteredMessages = filter === 'all' ? messages : messages.filter(m => m.type === filter);
  const unreadCount = messages.filter(m => !m.read).length;

  const groupByDate = (items) => {
    const today = new Date().toDateString();
    const yesterday = new Date(Date.now() - 86400000).toDateString();
    const groups = { 'Сегодня': [], 'Вчера': [], 'Ранее': [] };
    items.forEach(m => {
      const d = new Date(m.created_at || Date.now()).toDateString();
      if (d === today) groups['Сегодня'].push(m);
      else if (d === yesterday) groups['Вчера'].push(m);
      else groups['Ранее'].push(m);
    });
    return groups;
  };

  const groups = groupByDate(filteredMessages);

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🔔 Уведомления {unreadCount > 0 && <span style={{ background: '#EF4444', color: '#fff', borderRadius: 12, padding: '2px 10px', fontSize: 14, marginLeft: 8 }}>{unreadCount}</span>}</h2>

      {/* Настройки */}
      <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <h3 style={{ marginBottom: 12, color: '#F7DE8A' }}>⚙️ Настройки</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={settings.tax} onChange={() => toggleSetting('tax')} style={{ width: 18, height: 18 }} /> 📅 Налоговые напоминания
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={settings.cash} onChange={() => toggleSetting('cash')} style={{ width: 18, height: 18 }} /> 💰 Кассовые уведомления
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={settings.recommendations} onChange={() => toggleSetting('recommendations')} style={{ width: 18, height: 18 }} /> 💡 Рекомендации ИИ
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={settings.email_daily} onChange={() => toggleSetting('email_daily')} style={{ width: 18, height: 18 }} /> 📧 Email-сводка
          </label>

          <div style={{ marginTop: 8 }}>
            <span style={{ color: '#94A3B8', fontSize: 13, display: 'block', marginBottom: 6 }}>Частота:</span>
            <div style={{ display: 'flex', gap: 8 }}>
              {['instant', 'daily', 'weekly'].map(f => (
                <button key={f} onClick={() => setFrequency(f)}
                  style={{ padding: '6px 14px', background: settings.frequency === f ? '#F7DE8A' : '#0F172A', color: settings.frequency === f ? '#0F172A' : '#94A3B8', border: '1px solid #8A6636', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>
                  {f === 'instant' ? 'Мгновенно' : f === 'daily' ? 'Раз в день' : 'Раз в неделю'}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div style={{ marginTop: 12, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {!pushEnabled && (
            <button onClick={enablePush} style={{ padding: '10px 20px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>🔔 Включить push</button>
          )}
          {pushEnabled && <span style={{ color: '#10B981', fontSize: 13, alignSelf: 'center' }}>✅ Push включены</span>}
          <button onClick={sendDailyEmail} style={{ padding: '10px 20px', background: '#8A6636', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>📧 Отправить сводку</button>
          <button onClick={unsubscribe} style={{ padding: '10px 20px', background: 'none', border: '1px solid #EF4444', color: '#EF4444', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>🚫 Отписаться</button>
        </div>
      </div>

      {/* История email */}
      {showEmailLog && emailLog.length > 0 && (
        <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
          <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📧 История email</h3>
          {emailLog.map((l, i) => (
            <div key={i} style={{ padding: 10, marginBottom: 8, background: '#0F172A', borderRadius: 8, fontSize: 13 }}>
              <strong style={{ color: '#F7DE8A' }}>{l.subject}</strong>
              <span style={{ color: '#94A3B8', marginLeft: 8 }}>{l.created_at?.slice(0, 16).replace('T', ' ')}</span>
            </div>
          ))}
        </div>
      )}

      <button onClick={() => setShowEmailLog(!showEmailLog)} style={{ marginBottom: 16, background: 'none', border: '1px solid #8A6636', color: '#94A3B8', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>
        {showEmailLog ? 'Скрыть историю email' : 'Показать историю email'}
      </button>

      {/* Фильтры */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {Object.entries(FILTERS).map(([key, f]) => (
          <button key={key} onClick={() => setFilter(key)}
            style={{ padding: '8px 16px', background: filter === key ? '#F7DE8A' : '#1E293B', color: filter === key ? '#0F172A' : '#94A3B8', border: '1px solid #8A6636', borderRadius: 20, cursor: 'pointer', fontSize: 13, fontWeight: filter === key ? 700 : 500, display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>{f.icon}</span> {f.name}
          </button>
        ))}
      </div>

      {/* Лента по группам */}
      {Object.entries(groups).map(([date, items]) => (
        items.length > 0 && (
          <div key={date} style={{ marginBottom: 20 }}>
            <h4 style={{ color: '#F7DE8A', fontSize: 13, marginBottom: 8 }}>{date}</h4>
            {items.map((m, i) => (
              <div key={m.id || i} onClick={() => markRead(m.id)} style={{ padding: 12, marginBottom: 8, background: m.read ? '#1E293B' : 'rgba(99,102,241,0.1)', borderRadius: 8, border: '1px solid #8A6636', cursor: 'pointer', opacity: m.read ? 0.7 : 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <strong style={{ color: m.type === 'tax' ? '#F7DE8A' : m.type === 'cash' ? '#10B981' : '#6366F1' }}>{m.title}</strong>
                  <span style={{ fontSize: 11, color: '#94A3B8' }}>{m.created_at?.slice(11, 16)}</span>
                </div>
                <p style={{ fontSize: 13, color: '#94A3B8' }}>{m.message}</p>
              </div>
            ))}
          </div>
        )
      ))}

      {filteredMessages.length === 0 && <p style={{ color: '#94A3B8' }}>Нет уведомлений</p>}
    </div>
  );
}

export default Notifications;